module.exports = __webpack_public_path__ + "static/media/24UHCHR7.5b611025.jpg";